import { render, staticRenderFns } from "./RolePermissionsState.vue?vue&type=template&id=07607f3c&scoped=true&"
import script from "./RolePermissionsState.vue?vue&type=script&lang=js&"
export * from "./RolePermissionsState.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionsState.vue?vue&type=style&index=0&id=07607f3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07607f3c",
  null
  
)

export default component.exports